import React, { Suspense, lazy } from "react";
import styles from "./Layout.module.scss";
import Header from "../Header/Header";
import { useCommunity } from "../../context/community";
import { useHistory } from "react-router-dom";
import cn from "classnames";
import { PAGES } from "routes/PAGES";
import { getToken } from "services/auth";
import { isConnectLandingEnabled } from "pages/Welcome/components/ConnectLanding/parseConnectLandingConfig";
import { isKrasavaLandingEnabled } from "pages/Welcome/components/KrasavaLanding/parseKrasavaLandingConfig";
import { ChatNavSync } from "features/chat/components/ChatNavBadge";
import { useHideAdminBugReport } from "./useHideAdminBugReport";

const Footer = lazy(() => import('../Footer/Footer'));
const GoUpButton = lazy(() => import('../GoUpButton/GoUpButton'))

const Layout = ({ children }) => {
    const history = useHistory();
    const { community } = useCommunity();
    const { domain } = community;
    const customRoutes = [PAGES.WELCOME];

    const pathname = history.location.pathname;
    useHideAdminBugReport(pathname);
    const isLanding = pathname === PAGES.WELCOME;
    const isChatPage = pathname === PAGES.CHATS || pathname.startsWith(`${PAGES.CHATS}/`);
    const isPresentPage = pathname.endsWith('/live/present') || pathname.endsWith('/live/present/');
    const isAudienceLivePage = /\/live\/?$/.test(pathname);
    const isConnectLanding = isConnectLandingEnabled(community) && isLanding;
    const isKrasavaLanding = isKrasavaLandingEnabled(community) && isLanding;
    const isCustom = (domain === 'cpoctoavito' || domain === 'cpocto') && customRoutes.includes(pathname);

    if (domain === "connect-entire" && isLanding && !getToken()) {
        window.location.replace('https://my.entire.vc/connect/');
        return null;
    }

    return (
        <div className={cn(styles.wrapper, {
            [styles.landing]: isLanding,
            [styles.custom]: isCustom,
            [styles.connectLanding]: isConnectLanding,
            [styles.krasavaLanding]: isKrasavaLanding,
            [styles.chatPage]: isChatPage,
            [styles.presentPage]: isPresentPage,
        })} data-community={domain}>
            <ChatNavSync />
            {!isPresentPage && <Header />}
            <main className={styles.main}>
                {children}
            </main>
            {!isConnectLanding && !isKrasavaLanding && !isChatPage && !isPresentPage && !isAudienceLivePage && (
                <Suspense fallback={<div></div>}>
                    <Footer />
                    <GoUpButton />
                </Suspense>
            )}
        </div>
    )
}

export default Layout
